import Vue from 'vue'
import Router from 'vue-router'
// 传屏下载app H5界面 中转
const thescreenh5 = () => import('@/thescreen/h5')
// 文香传屏 《用户协议》 PC
const wenxianguser = ()=> import('@/thescreen/userxieyi')
// 文香传屏 《用户协议》 H5
const wenxianguserH5 = ()=> import('@/thescreen/h5textuser')
// 文香传屏 《隐私协议》 H5
const privacyagreementH5 = ()=> import('@/thescreen/privacyagreement')

const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error)
}
Vue.use(Router)

const router = new Router({
    // mode: 'history',
    routes: [
        { // 传屏
            path: '/thescreenh5',
            name: 'thescreenh5',
            component: thescreenh5
        },
        { // 传屏 《用户协议》PC
            path: '/wenxianguser',
            name: 'wenxianguser',
            component: wenxianguser
        },
        { // 传屏 《用户协议》H5
            path: '/wenxianguserH5',
            name: 'wenxianguserH5',
            component: wenxianguserH5
        },{ // 传屏 《用户协议》H5
            path: '/privacyagreementH5',
            name: 'privacyagreementH5',
            component: privacyagreementH5
        }
    ]
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js